export default "__VITE_ASSET__DgVYqRa$__"